/* mw-curador: chat do Curador via App Proxy (/apps/curador, docs/CURADOR.md).
   Contrato v2: a resposta ja traz `produtos[]` com o card pronto (nome, tipo,
   pais, preco formatado, img, url, variantId, disponivel), na ordem de
   `handles`. O tema NAO resolve mais catalogo: o JSON inline #mw-catalogo saiu
   porque `collection.products` fora de paginate para em 50 e o catalogo real
   tem 191 rotulos. Resposta v1 (sem `produtos`) = texto sem cards.
   `disponivel: false` troca ADICIONAR por "Me avisa" apontando url + #avise (o
   formulario mora na PDP; zero fetch aqui).
   Curador fora do ar (proposta aprovada em 2026-08-27): qualquer falha (rede,
   HTTP, timeout de 12s, resposta invalida) mostra a linha de estado
   (data-offline) NO LUGAR da resposta e revela o painel [data-mw-offline], que
   ja veio pronto do Liquid com 5 ocasioes em <details>. O campo de digitar nunca
   e desabilitado: a proxima mensagem tenta o backend de novo, e na primeira
   resposta boa o painel volta a ficar oculto - sem trocar de tela, sem toast e
   sem roubar o foco. Cada falha manda um beacon pro /apps/curador/evento: e a
   unica falha que o servidor nao ve (ela acontece antes de a requisicao chegar
   la, ou depois de ele ja ter respondido errado).
   Persistencia: localStorage mw_curador (acompanha as paginas); mensagem antiga
   gravada com `slugs` (formato v1) renderiza so o texto. Cada resposta guarda o
   `ts` em que chegou: card restaurado com mais de 24h perde o botao ADICIONAR e
   fica so com o link para a PDP (preco, estoque e ate o rotulo podem ter mudado
   entre a conversa e a volta; a PDP e a unica fonte fresca). Mensagem sem `ts`
   (gravada antes desta versao) conta como velha. */
(function () {
  'use strict';
  var raiz = document.querySelector('[data-mw-curador]');
  if (!raiz) return;

  function attr(n) { return raiz.getAttribute(n); }
  var chat = raiz.querySelector('[data-mw-chat]');
  var fluxo = raiz.querySelector('[data-mw-fluxo]');
  var offline = raiz.querySelector('[data-mw-offline]');
  var composer = raiz.querySelector('[data-mw-composer]');
  var btnEnviar = raiz.querySelector('[data-mw-enviar]');
  var btnNova = raiz.querySelector('[data-mw-nova]');
  var digitando = raiz.querySelector('[data-mw-digitando]');
  var SAUDACAO = attr('data-saudacao');
  var RESET = attr('data-reset');
  var TXT_VER = attr('data-txt-ver');
  var TXT_ADD = attr('data-txt-adicionar');
  var TXT_CARRINHO = attr('data-txt-no-carrinho');
  var TXT_ESPERA = attr('data-txt-adicionando');
  var TXT_ESGOTOU = attr('data-txt-esgotou');
  var TXT_ALT = (raiz.getAttribute('data-txt-alt') || 'Garrafa do vinho') + ' ';
  var TXT_AVISA = attr('data-txt-me-avisa');
  var OFFLINE = attr('data-offline');

  /* --- persistencia --- */
  function lerConversa() {
    try { return JSON.parse(localStorage.getItem('mw_curador')) || []; } catch (e) { return []; }
  }
  function salvarConversa(c) {
    try { localStorage.setItem('mw_curador', JSON.stringify(c)); } catch (e) {}
  }
  /* A2 do sistema de eventos (5.1): a conversa e relida a CADA abertura do
     drawer, nao uma vez no boot. A pagina do evento semeia a conversa neste
     mesmo localStorage DEPOIS que este modulo ja carregou, entao ler so no boot
     faria o "Presentear" abrir o drawer com a conversa velha - o mecanismo de
     compra do evento inteiro passa por aqui. */
  var conversa = [];
  function carregar() {
    conversa = lerConversa();
    if (!conversa.length) conversa = [{ de: 'c', texto: SAUDACAO }];
  }
  carregar();

  /* --- id anonimo da conversa (acompanha o backend; nunca PII) --- */
  function sidCurador() {
    try {
      var s = localStorage.getItem('mw_curador_sid');
      if (!s) {
        s = (self.crypto && crypto.randomUUID) ? crypto.randomUUID()
          : (Date.now() + '-' + Math.random().toString(16).slice(2));
        localStorage.setItem('mw_curador_sid', s);
      }
      return s;
    } catch (e) { return 'anon-' + Date.now(); }
  }

  /* --- backend do Curador via App Proxy; qualquer falha -> painel de fora do ar.
     O motivo viaja como string na rejeicao para o beacon poder classifica-la;
     'rede' cobre tambem o corpo ilegivel, que rejeita igual a queda de conexao. --- */
  function naoErro(m) { return !m.erro; }

  function curadorRemoto(ctx) {
    var ctrl = new AbortController();
    var t = setTimeout(function () { ctrl.abort(); }, 12000);
    /* a linha de fora do ar nunca vai no historico: o Curador nao disse aquilo */
    var ms = conversa.filter(naoErro).slice(-12).map(function (m) { return { de: m.de, texto: String(m.texto).slice(0, 1000) }; });
    /* ctx.produto (P4 do lancamento; docs/CURADOR.md, "Contexto da pagina"): so
       na fala que saiu do botao da pagina de rotulo esgotado, que e a ultima.
       Nao e gravado na conversa: a fala seguinte vai sem ele. */
    if (ctx) ms[ms.length - 1].ctx = ctx;
    return fetch('/apps/curador', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        mensagens: ms,
        sid: sidCurador()
      }),
      signal: ctrl.signal
    }).then(function (r) {
      clearTimeout(t);
      if (!r.ok) throw 'http';
      return r.json();
    }).then(function (j) {
      if (!j || !j.ok || typeof j.texto !== 'string') throw 'resposta';
      /* v1 (sem `produtos`) segue valendo: texto sem cards */
      var p = (j.v >= 2 && Array.isArray(j.produtos)) ? j.produtos.slice(0, 3) : [];
      return { texto: j.texto, produtos: p };
    });
  }

  /* --- atribuicao: avisa o backend quando um add veio de uma sugestao --- */
  function eventoAdd(handle) {
    try {
      fetch('/apps/curador/evento', {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sid: sidCurador(), tipo: 'add', handle: handle })
      }).catch(function () {});
    } catch (e) {}
  }

  /* --- medicao do fora do ar: sendBeacon rotula o corpo como text/plain e a rota
     parseia o texto cru; sem sendBeacon, fetch keepalive. Nunca bloqueia a UI. --- */
  function eventoFalha(motivo) {
    try {
      var corpo = JSON.stringify({ sid: sidCurador(), tipo: 'fallback', motivo: motivo });
      if (navigator.sendBeacon && navigator.sendBeacon('/apps/curador/evento', corpo)) return;
      fetch('/apps/curador/evento', { method: 'POST', keepalive: true, body: corpo }).catch(function () {});
    } catch (e) {}
  }

  /* --- painel de fora do ar: revelado na falha, escondido na primeira resposta boa.
     O foco so vai pro container na revelacao (SC 2.4.3); ao esconder, ninguem o
     rouba de volta. O focus trap do drawer recalcula os focaveis a cada Tab
     (mw-core.js, funcao focaveis), entao a lista nova entra sozinha. --- */
  var offlineAtivo = false;
  function sincronizarOffline() {
    if (!offline) return;
    var estava = offline.hasAttribute('hidden');
    offline.toggleAttribute('hidden', !offlineAtivo);
    if (offlineAtivo && estava) offline.focus();
  }

  /* --- handles ja no carrinho (mw-cart.js dispara mw:cart com o cart inteiro) ---
     `esperando`: handles com o POST do add em voo. O card redesenhado nesse
     meio (a pagina do evento reabre a conversa logo no 200, antes do mw:cart
     que atualiza `noCarrinho`) nasce em "Adicionando...", travado, e nunca
     num ADICIONAR que somaria outra garrafa. */
  var noCarrinho = {};
  var esperando = {};
  document.addEventListener('mw:cart', function (e) {
    noCarrinho = {};
    var itens = (e.detail && e.detail.items) || [];
    itens.forEach(function (i) { noCarrinho[i.handle] = true; });
    render();
  });

  /* --- render (DOM API, sem innerHTML de dados) --- */
  function el(tag, cls, texto) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (texto) n.textContent = texto;
    return n;
  }
  function link(cls, texto, href) {
    var a = el('a', cls, texto);
    a.href = href;
    return a;
  }

  var VALIDADE_CARD = 864e5; /* 24h */

  function cardSugestao(v, velho) {
    /* so URL relativa da propria loja vira href (o backend monta /products/<handle>) */
    if (!v || !v.url || v.url.charAt(0) !== '/' || !v.nome) return null;
    var card = el('div', 'mw-cur-card');
    var thumb = link('mw-cur-thumb', null, v.url);
    if (v.img) {
      var img = document.createElement('img');
      img.src = v.img;
      img.alt = TXT_ALT + v.nome;
      img.loading = 'lazy';
      img.width = 44;
      img.height = 60;
      thumb.appendChild(img);
    }
    card.appendChild(thumb);
    var info = el('div', 'mw-cur-info');
    info.appendChild(link('mw-cur-nome', v.nome, v.url));
    var meta = v.tipo || '';
    if (v.pais) meta = meta ? meta + ' · ' + v.pais : v.pais;
    info.appendChild(el('span', 'mw-cur-meta', meta));
    /* linha propria: preco a esquerda, acoes VER/ADICIONAR a direita (prototipo) */
    var linha = el('div', 'mw-cur-linha');
    linha.appendChild(el('span', 'mw-cur-preco', v.preco));
    var acoes = el('div', 'mw-cur-acoes');
    acoes.appendChild(link('mw-cur-ver', TXT_VER, v.url));
    if (v.disponivel === false) linha.appendChild(el('span', 'mw-cur-esgotou', TXT_ESGOTOU));
    if (v.disponivel === false) {
      /* esgotado: o CTA vira o avise-me da PDP, nunca um beco */
      var avisa = link('mw-cur-add', TXT_AVISA, v.url + '#avise');
      avisa.setAttribute('aria-label', TXT_AVISA + ': ' + v.nome);
      acoes.appendChild(avisa);
    } else if (!v.variantId || velho) {
      /* sem variante legivel, ou card velho demais para prometer preco e estoque:
         so VER (nunca um ADICIONAR que pode falhar ou cobrar outro valor) */
    } else {
      var add = el('button', 'mw-cur-add');
      add.type = 'button';
      if (noCarrinho[v.handle]) {
        /* vinho ja no carrinho: card nasce em "NO CARRINHO ✓" */
        add.textContent = TXT_CARRINHO;
        add.classList.add('mw-cur-ok');
        add.disabled = true;
      } else if (esperando[v.handle]) {
        add.textContent = TXT_ESPERA;
        add.disabled = true;
      } else {
        add.textContent = TXT_ADD;
        add.addEventListener('click', function () {
          add.disabled = true;
          add.textContent = TXT_ESPERA;
          esperando[v.handle] = 1;
          /* `v.props` chega nos cards semeados pela pagina do evento e leva o
             claim assinado `_mw_ev`, que e o unico elo entre o pedido e o
             evento. Card do endpoint normal nao tem props e cai no default. */
          /* o aviso do "adicionado" tambem nasce aqui (no espaco dele dentro do
             Curador, mw-cart.js), NO 200: o addVariant resolve ali e a
             sincronizacao corre atras (P14a). O card e o proprio `d` do aviso
             (nome, url, preco ja formatado, img). Recusado, o aviso diz por que:
             o 422 de estoque era engolido. Card redesenhado no meio (o `add`
             saiu da tela): redesenha de novo, agora com o estado certo. */
          window.MWCart.addVariant(v.variantId, v.props || { _curador: '1' }).then(function () {
            delete esperando[v.handle];
            noCarrinho[v.handle] = true;
            window.MWCart.avisar('ok', v);
            eventoAdd(v.handle);
            if (!add.isConnected) return render();
            add.textContent = TXT_CARRINHO;
            add.classList.add('mw-cur-ok');
          }, function (r) {
            delete esperando[v.handle];
            window.MWCart.falha(r, v.variantId, v);
            if (!add.isConnected) return render();
            add.disabled = false;
            add.textContent = TXT_ADD;
          });
        });
      }
      acoes.appendChild(add);
    }
    linha.appendChild(acoes);
    info.appendChild(linha);
    card.appendChild(info);
    return card;
  }

  function render() {
    /* limpa so as mensagens: o indicador digitando mora no fim do fluxo e fica */
    Array.prototype.slice.call(fluxo.querySelectorAll('.mw-cur-msg, .mw-cur-user')).forEach(function (n) {
      n.remove();
    });
    var agora = Date.now();
    conversa.forEach(function (m) {
      var velho = !(m.ts > agora - VALIDADE_CARD);
      var linha = el('div', m.de === 'c' ? 'mw-cur-msg' : 'mw-cur-user');
      linha.appendChild(el('p', null, m.texto));
      var produtos = m.produtos || [];
      if (produtos.length) {
        var sugestoes = el('div', 'mw-cur-sugestoes');
        produtos.forEach(function (v) { var c = cardSugestao(v, velho); if (c) sugestoes.appendChild(c); });
        linha.appendChild(sugestoes);
      }
      fluxo.insertBefore(linha, digitando);
    });
    /* conversa so com a saudacao: atalhos genericos a vista e NOVA fora; com
       conversa em andamento, o contrario (CSS em curador-drawer.liquid) */
    raiz.classList.toggle('mw-cur-vazia', conversa.length <= 1);
    chat.scrollTop = chat.scrollHeight;
    /* por ultimo: o foco no painel revelado tem a palavra final sobre o scroll,
       e ele mostra a apresentacao antes da lista */
    sincronizarOffline();
  }

  function perguntar(texto, ctx) {
    if (!texto) return;
    if (!digitando.hasAttribute('hidden')) return; /* bloqueia envio duplo */
    conversa.push({ de: 'u', texto: texto });
    salvarConversa(conversa);
    render();
    digitando.removeAttribute('hidden');
    chat.scrollTop = chat.scrollHeight;
    curadorRemoto(ctx)
      .catch(function (e) {
        eventoFalha(typeof e === 'string' ? e : (e && e.name === 'AbortError' ? 'timeout' : 'rede'));
        return { texto: OFFLINE, produtos: [], erro: true };
      })
      .then(function (resp) {
        offlineAtivo = !!resp.erro;
        conversa.push({ de: 'c', texto: resp.texto, produtos: resp.produtos, ts: Date.now(), erro: resp.erro });
        /* a linha de fora do ar e mostrada, nunca gravada: erro nao vira historico na proxima visita */
        salvarConversa(conversa.filter(naoErro));
        digitando.setAttribute('hidden', '');
        render();
      });
  }

  /* --- composer: Enter envia, Shift+Enter quebra; textarea cresce --- */
  function enviar() {
    var v = composer.value.trim();
    if (!v) return;
    if (!digitando.hasAttribute('hidden')) return; /* aguardando resposta: nao descarta o texto */
    composer.value = '';
    composer.style.height = '';
    perguntar(v);
  }
  composer.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); enviar(); }
  });
  composer.addEventListener('input', function () {
    composer.style.height = 'auto';
    composer.style.height = Math.min(120, composer.scrollHeight) + 'px';
  });
  btnEnviar.addEventListener('click', enviar);

  if (btnNova) btnNova.addEventListener('click', function () {
    conversa = [{ de: 'c', texto: RESET }];
    salvarConversa(conversa);
    render();
  });

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-mw-chip]');
    if (chip) {
      e.preventDefault();
      /* atalho de DENTRO do drawer: ele some com a conversa em andamento, entao
         o foco nunca pode ficar nele (cairia no body). Pelo teclado (click com
         detail 0) vai para o campo; no toque vai para a conversa, sem abrir o
         teclado do celular por cima da resposta. O drawer ja esta aberto. */
      var dentro = raiz.contains(chip);
      if (!dentro && window.MW) window.MW.abrir('curador');
      perguntar(chip.getAttribute('data-mw-chip'));
      if (dentro) {
        if (e.detail === 0) composer.focus();
        else chat.focus({ preventScroll: true });
      }
      return;
    }
    var perg = e.target.closest('[data-mw-curador-pergunta]');
    if (perg) {
      e.preventDefault();
      if (window.MW) window.MW.abrir('curador');
      /* PDP de rotulo esgotado: o handle vai junto, so nesta fala (P4) */
      var h = perg.getAttribute('data-mw-curador-produto');
      perguntar(perg.getAttribute('data-mw-curador-pergunta'), h ? { produto: h } : null);
    }
  });

  /* abrir com conversa persistida: mostra o fim do chat, nao o topo */
  document.addEventListener('mw:drawer', function (e) {
    if (e.detail && e.detail.nome === 'curador' && e.detail.aberto) {
      carregar();
      render();
      chat.scrollTop = chat.scrollHeight;
    }
  });

  render();

  /* deep-link ?curador=1 (J9): chega por link de email -> abre o drawer sozinho.
     window.MW (mw-core.js) ja carregou: defer preserva a ordem dos scripts. */
  try {
    if (/[?&]curador=1(?:&|$)/.test(location.search) && window.MW) window.MW.abrir('curador');
  } catch (e) {}
})();
